<template>
  <div class="switcher" ref="langRef" v-if="currentLocale">
    <div class="switcher__button" @click="setSwitcherVisible(!isSwitcherVisible)">
      <p class="switcher__button-text">{{ currentLocale.name }}</p>
    </div>
    <div class="switcher__menu" :class="[{active: isSwitcherVisible}]">
      <p
          class="switcher__menu-button"
          @click="switchLocale(locale.code)"
          v-for="locale of locales"
          :key="locale.code"
      >
        {{ locale.name }}
      </p>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import translations from "@/core/helpers/translations.js";
import {useRoute, useRouter} from "vue-router";
import { onClickOutside } from '@vueuse/core'
import {Languages} from "@/core/api/languages.js";
import translation from "@/core/helpers/translations.js";

const route = useRoute()
const router = useRouter()

const locales = ref([])

const isSwitcherVisible = ref(false)
const setSwitcherVisible = (state) => {
  isSwitcherVisible.value = state
}

const langRef = ref(null)
onClickOutside(langRef, () => isSwitcherVisible.value = false)

const currentLocale = ref(null)

const getLanguages = async () => {
  const res = await Languages.getLanguages()
  locales.value = res.data?.languages.filter((locale) => translation.supportedLocales.includes(locale.code));
  currentLocale.value = locales.value.find((locale) => locale.code === translation.currentLocale)
}

const switchLocale = async (newLocale) => {
  setSwitcherVisible(false)

  translations.switchLanguage(newLocale)

  await router.push({
    name: route.name,
    params: {
      ...route.params,
      locale: newLocale
    },
    query: { ...route.query }
  })
}

watch (
  () => translation.currentLocale,
  () => {
    currentLocale.value = locales.value.find((locale) => locale.code === localStorage.getItem('gift-digital-user-locale'))
  }
)

onMounted(async () => {
  await getLanguages()
})
</script>

<style lang="scss" scoped>
.switcher {
  position: relative;
  z-index: 3;

  &__button {
    cursor: pointer;
    display: flex;
    gap: 5px;

    &-text {
      transition: 0.2s;
      width: 100%;
      padding: 5px 10px;
      box-sizing: content-box;
      background-color: #004b0d;
      border-radius: 5px;

      color: $white;
    }
  }

  &__menu {
    width: 100%;
    position: absolute;
    z-index: 3;
    bottom: 110%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #004b0d;
    display: flex;
    flex-direction: column;
    max-height: 0;
    overflow: hidden;
    transition: 0.2s;
    border-radius: 5px;

    &.active {
      max-height: 1000px;
    }

    &-button {
      width: 100%;
      cursor: pointer;
      padding: 5px 10px;
      background-color: #004b0d;
      transition: 0.1s;
      color: $white;

      &:hover {
        background-color: #01AC1B;
      }
    }
  }
}

//@media (max-width: 1680px) {
//  .switcher {
//    &__menu {
//      top: 44px;
//    }
//  }
//}
</style>